module.exports = __webpack_public_path__ + "static/media/google-play-badge-ru.f12f9a8f.svg";